import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import Button from "../../../modules/commons/Button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleDDL from "../../../modules/SimpleDDL";
import Api from "../../../Services/Api";
import {HttpStatus, Status} from "../../common/Constants";
import {flattenFormGroupObject, mapToObjectDDL} from "../../common/mapper";
import MasterBankModifying from "./masterBankModifying";
import MasterBankFilter from "./masterBankFilter";
import {formGroup, tableColumns} from "./config";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../Services/Utils";

class MasterBank extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
                    return <>{rowNumber}</>;
                },
            },
        },
        ...tableColumns,
        {
            name: "status",
            label: "Status",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <ToggleButton
                        value={R.equals(val, Status.ACTIVE)}
                        onToggle={(value) => this.handleToggleChange(value, rowIndex)}
                    />
                ),
                sort: false,
            },
        },
        {
            name: "bankCode",
            label: "Aksi",
            options: {
                customBodyRender: (val) => {
                    return (
                        <FlexView vAlignContent="center">
                            <Button
                                className="btnAct"
                                onClick={() => this.handleModifyingModalVisibility(val)}
                            >
                                <i
                                    className="fa fa-lw fa-pencil-alt"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                            <Button
                                className="btnAct margin-left-15px"
                                onClick={() => this.handleShowAlert(val)}
                            >
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                        </FlexView>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            paramFilters: {},
            modifyingData: {},
            selectedData: null,
            isFilterModalsVisible: false,
            modifyingVisible: false,
            submittedFilterData: {},
            filterData: {},
            limit: 5,
            page: 1,
            toTalData: 0,
            print: false,
            cabangOptions: [],
            cabangRawOptions: [],
            cabangFrontFilter: null,
            deleteId: null,
            showAlert: false,
            alert: false,
            textAlert: "",
            isFetch: false,
            alertCannotDelete: false,
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        const responses = await Api.create(
            "NAGAMAS_MASTER_DATA"
        ).findAllMasterCabang();
        if (responses.ok && !R.isEmpty(responses.data.data)) {
            const filteredData = responses.data.data
                .filter((item) =>
                    this.props.menuAccess
                        .map((data) => data.idRefObj)
                        .includes(item.kodeCabang)
                )
                .map(({kodeCabang, namaDealer}) => ({
                    label: namaDealer,
                    value: kodeCabang,
                }));
            if (filteredData.length > 0) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    cabangOptions: filteredData,
                    cabangFrontFilter: filteredData[0],
                    cabangRawOptions: responses.data.data.map(item => mapToObjectDDL(item.namaDealer, item.kodeCabang)),
                    paramFilters: {
                        kodecabang: [filteredData[0].value],
                    },
                }));
            }
            await this.fetchData({kodecabang: [filteredData[0].value]});
        }
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (prevProps, prevState) => {
        // Memastikan state paramFilters berubah dan komponen melakukan render ulang
        if (
            (prevState.page !== this.state.page ||
                prevState.limit !== this.state.limit) &&
            !this.state.isFetch
        ) {
            this.handleTriggerLoading();
            await this.fetchData(this.state.submittedFilterData, this.state.page, this.state.limit);
            this.handleTriggerLoading();
        }
    }

    refetch = async () => {
        await this.fetchData(this.state.submittedFilterData, this.state.page, this.state.limit);
    };

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({...prevValue, isFetch: true, totalData: 0}));
        const body = {
            paramFilters: filter,
            page,
            limit,
        };
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterBank,
            menuName: "Master Bank",
            setError: this.props.setError,
            args: body
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                data: response.data.data,
                totalData: response.data.totalData,
                submittedFilterData: filter,
                page,
                limit,
            }));
        }
        this.setState((prevValue) => ({...prevValue, isFetch: false}));
    };

    handleToggleChange = async (value, index) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const requestBody = {
            id: this.state.data[index].bankCode,
            status: !value ? Status.ACTIVE : Status.INACTIVE,
        };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateStatusMasterBank,
            menuName: "Master Bank",
            setError: this.props.setError,
            args: requestBody,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.refetch();
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleShowAlert = (bankCode) => {
        this.setState((prevValue) => ({
            ...prevValue,
            showAlert: !prevValue.showAlert,
            deleteId: bankCode,
        }))
    };

    handleShowAlertCannotDelete = () => {
        this.setState((prevValue) => ({...prevValue, alertCannotDelete: !prevValue.alertCannotDelete}));
    };

    handleDelete = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteMasterBank,
            menuName: "Master Bank",
            setError: this.props.setError,
            args: this.state.deleteId,
        });
        this.handleShowAlert(null);
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                alert: true,
                textAlert: "Data Berhasil Dihapus",
            }))
            await this.refetch();
        } else if (res.data.code === 509) {
            this.handleShowAlertCannotDelete();
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleSubmitModifying = async (controls) => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
        }));
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            kodeCabang: formGroup.kodeCabang.map((value) => value.value),
        };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").saveMasterBank,
            menuName: "Master Bank",
            setError: this.props.setError,
            args: requestBody,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleModifyingModalVisibility();
            this.setState((prevValue) => ({
                ...prevValue,
                alert: true,
                textAlert: "Data tersimpan",
            }));
            await this.refetch();
        }
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
        }));
    };

    handleModifyingModalVisibility = async (id) => {
        if (!R.isNil(id)) {
            try {
                const response = await Api.create(
                    "NAGAMAS_MASTER_DATA"
                ).getMasterBankById(id);
                if (response.ok) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        selectedData: {
                            ...response.data.data,
                            kodeCabang: response.data.data.cabang.map((c) =>
                                mapToObjectDDL(c.cabang.namaDealer, c.cabang.kodeCabang)
                            ),
                        },
                        modifyingVisible: !prevValue.modifyingVisible,
                    }));
                }
            } catch (error) {
                // TODO
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            isFilterModalsVisible: !prevValue.isFilterModalsVisible,
        }));
    };

    handleStateChange = (callback) => {
        this.setState(callback, () => {
        });
    };

    handleClearFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {},
        }));
    };

    handleSubmitFilter = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
        }));
        let {filterData} = this.state;
        let req =
            {
                ...filterData,
                kodecabang: !R.isNil(filterData.kodecabang) ?
                    filterData?.kodecabang?.map(item => item.value) :
                    [this.state.cabangFrontFilter.value]
            };
        if (!R.isNil(filterData.kodecabang)) {
            this.setState((prevValue) => ({
                ...prevValue,
                cabangFrontFilter: null,
            }));
        }
        await this.fetchData(req);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            isFilterModalsVisible: !prevValue.isFilterModalsVisible,
        }));
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading}));
    };

    getFilterDataValue = (fieldName, fallbackValue = []) => {
        return this.state[fieldName] || fallbackValue; // Ambil nilai dari state
    };

    getLabelForValue = (value, options) => {
        const match = options.find((option) => option.value === value);
        return match ? match.label : value;
    };

    handleValueChange = async (name, value) => {
        this.handleTriggerLoading();
        this.setState((prevValue) => ({
            ...prevValue,
            cabangFrontFilter: value,
            filterData: {},
        }));
        if (!R.isNil(value)) {
            await this.fetchData({kodecabang: [value.value]})
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                data: [],
                totalData: 0,
                page: 1,
                isFetch: true,
            }));
        }
        this.handleTriggerLoading();
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            page: tableState.page + 1,
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            page: 1,
            totalData: 0,
            limit: tableState.rowsPerPage,
        }));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between", alignItems: "center"}}
                        className="margin-bottom-20px margin-top-5px"
                    >
                        <SimpleDDL
                            id="select_options_nama_cabang"
                            box="search"
                            name="cabangFrontFilter"
                            containerclassname="width width-250px"
                            placeholder="Nama cabang hak akses"
                            isClearable
                            options={this.state.cabangOptions}
                            value={this.state.cabangFrontFilter}
                            onChange={(value) =>
                                this.handleValueChange("cabangFrontFilter", value)
                            }
                        />
                        <Button
                            type="button"
                            className="btn background-red"
                            onClick={this.handleFilterVisibility}
                        >
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
                        </Button>
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.data}
                        columns={this.tableColumns}
                        toCount={this.state.totalData}
                        rowsPerPage={this.state.limit}
                        page={this.state.page - 1}
                        options={defaultTableChange(
                            this.handleChangePage,
                            this.handleRowsPerPage
                        )}
                        footerAdditionalButtons={
                            <>
                                <SimpleButton
                                    onClick={() => this.handleModifyingModalVisibility()}
                                >
                  <span>
                    <i className="fa fa-plus margin-right-10px"></i>
                  </span>
                                    Tambah
                                </SimpleButton>
                                <SimpleButton secondary onClick={this.handlePrint}>
                                    Cetak
                                </SimpleButton>
                            </>
                        }
                    />
                </Container>
                {this.state.modifyingVisible && (
                    <MasterBankModifying
                        formGroup={formGroup}
                        cabangOptions={this.state.cabangRawOptions}
                        initialValues={this.state.selectedData}
                        activity={!R.isNil(this.state.selectedData) ? "Edit" : "Form"}
                        visible={this.state.modifyingVisible}
                        onClickClose={this.handleModifyingModalVisibility}
                        onSubmit={this.handleSubmitModifying}
                    />
                )}
                {this.state.isFilterModalsVisible && (
                    <MasterBankFilter
                        state={this.state}
                        onClickClose={this.handleFilterVisibility}
                        onSetState={this.handleStateChange}
                        onSubmit={this.handleSubmitFilter}
                        onReset={this.handleClearFilter}
                    />
                )}
                {this.state.loading && (
                    <SimpleLoadingOverlay active={this.state.loading}/>
                )}
                {this.state.print && (
                    <SimplePrintTable onClearPrint={this.handlePrint}/>
                )}
                {this.state.alert && (
                    <SimpleAlert
                        title="Informasi"
                        content={this.state.textAlert}
                        visible={this.state.alert}
                        onClickClose={() => this.setState({alert: false})}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton secondary onClick={() => this.setState({alert: false})}>
                                    OK
                                </SimpleButton>
                            </FlexView>
                        }
                    />
                )}

                {this.state.showAlert && (
                    <SimpleAlert
                        visible={this.state.showAlert}
                        onClickClose={() => this.handleShowAlert(null)}
                        content={"Apakah anda yakin ingin menghapus data ini?"}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleDelete} text={"Ya"}/>
                                <SimpleButton onClick={() => this.handleShowAlert(null)} text={"Tidak"}/>
                            </FlexView>
                        }
                    />
                )}
                {this.state.alertCannotDelete && (
                  <SimpleAlert
                    visible={this.state.alertCannotDelete}
                    onClickClose={() => this.handleShowAlertCannotDelete()}
                    content={
                        <div>
                            <p>Data tidak dapat dihapus, sudah masuk kedalam transaksi.</p>
                        </div>
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <SimpleButton onClick={() => this.handleShowAlertCannotDelete()}>
                                OK
                            </SimpleButton>
                        </FlexView>
                    }/>
                )}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterBank);
